import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionsItemFailuresDashboard = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionsItemFailuresDashboard/InspectionsItemFailuresDashboard"
    )
);

export const InspectionItemFailuresList = () => {
  return (
    <Layout>
      <InspectionsItemFailuresDashboard />
    </Layout>
  );
};
